// ======================================================================
// File Name       : ContentDocumentDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { Component } from 'react';
import { Col, Form, Image } from 'react-bootstrap';
import { DOCUMENT_TYPE_DOCX_PPTX } from '../../constants/ContentConstant';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import ItemDocumentThumbnail from '../../images/item_document_thumbnail.svg';
import { downLoadFile } from '../../utils/ApiUtils';

class ContentDocumentDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toShow: false,
      dataUrl: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    const { imageUrl } = nextProps;
    if (imageUrl) {
      downLoadFile(imageUrl).then((blob) => {
        const reader = new FileReader();
        const blobObject = new Blob([blob]);
        reader.readAsDataURL(blobObject);
        reader.onload = () => {
          const dataUrl = reader.result;
          this.setState({
            toShow: true,
            dataUrl,
          });
        };
      }).catch(() => {
        this.setState({
          toShow: true,
          dataUrl: ItemDocumentThumbnail,
        });
      });
    } else {
      this.setState({
        toShow: true,
        dataUrl: ItemDocumentThumbnail,
      });
    }
  }
  render() {
    const {
    contentSecernId,
    contentName,
    documentUpdateStatus,
    documentName,
    documentPdfName,
    documentType,
    isDetail,
    } = this.props;
    const getDocumentStatusText = (status) => {
      try {
        const convertedValue = parseInt(status, 10);
        return SELECT_BOX_DATA.DOCUMENT_UPDATE_STATUS.filter(
          item => item.value === convertedValue)[0].name;
      } catch (error) {
        return status;
      }
    };
    const { toShow, dataUrl } = this.state;
    const isTranslateDocument = DOCUMENT_TYPE_DOCX_PPTX.indexOf(documentType) > -1;
    return (
      <Col sm={12} id="contentDocumentDetail">
        <Form className='form-horizontal'>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">
              コンテンツ識別ID
              </Col>
            <Col sm={9} className="padding-top-bottom-10">
              { contentSecernId }
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">
              コンテンツ名
              </Col>
            <Col sm={9} className="padding-top-bottom-10" >
              { contentName }
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">
              登録ファイル名
            </Col>
            {isDetail && documentName && (
              <Col sm={9} className="padding-top-bottom-10">
                <span
                  role="button"
                  tabIndex={0}
                  className="text-decoration-underline text-outline-none bold text-primary"
                  onClick={() => this.props.downloadDocument(documentName)}
                >
                  {documentName}
                  <i
                    role="button"
                    className="bi bi-download text-primary padding-left-5"
                  />
                </span>
              </Col>
            )}
            {!isDetail && (
              <Col sm={9} className="padding-top-bottom-10">{documentName}</Col>
            )}
          </Form.Group>
          {isDetail && isTranslateDocument && (
            <Form.Group className="form-info">
              <Col sm={3} className="form-label">
                配信ファイル名
              </Col>
              {documentPdfName && (
                <Col sm={9} className="padding-top-bottom-10">
                  <span
                    role="button"
                    tabIndex={0}
                    className="text-decoration-underline text-outline-none bold text-primary"
                    onClick={() => this.props.downloadDocument(documentPdfName)}
                  >
                    {documentPdfName}
                    <i
                      role="button"
                      className="bi bi-download text-primary padding-left-5"
                    />
                  </span>
                </Col>
              )}
            </Form.Group>
            )
          }

          {isDetail && (
            <Form.Group className="form-info">
              <Col sm={3} className="form-label">
                  ステータス
                </Col>
              <Col sm={9} className="padding-top-bottom-10">
                { getDocumentStatusText(documentUpdateStatus) }
              </Col>
            </Form.Group>
          )}
          {isDetail &&
            <Form.Group className="form-info label-middle" >
              <Col sm={3} className="form-label">
                サムネイル画像
                </Col>
              <Col sm={9} className="padding-top-bottom-10">
                { !toShow && dataUrl === '' &&
                  <i
                    role="button"
                    className="bi bi-arrow-clockwise refresh-animate"
                  />
                }
                { toShow && dataUrl !== ItemDocumentThumbnail &&
                  <Image className="thumbnail" alt="NoImage" src={dataUrl} />
                }
                { toShow && dataUrl === ItemDocumentThumbnail &&
                  <Image className="thumbnail" alt="NoImage" src={ItemDocumentThumbnail} />
                }
              </Col>
            </Form.Group>
          }
        </Form>
      </Col>
    );
  }
}

export default ContentDocumentDetail;
